/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertSchemaDefinitionRequest
 */
export interface UpsertSchemaDefinitionRequest {
    /**
     * 
     * @type {string}
     * @memberof UpsertSchemaDefinitionRequest
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertSchemaDefinitionRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertSchemaDefinitionRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertSchemaDefinitionRequest
     */
    purpose?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertSchemaDefinitionRequest
     */
    version?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertSchemaDefinitionRequest
     */
    active?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpsertSchemaDefinitionRequest
     */
    schema: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpsertSchemaDefinitionRequest
     */
    metadata?: { [key: string]: any; };
}

/**
 * Check if a given object implements the UpsertSchemaDefinitionRequest interface.
 */
export function instanceOfUpsertSchemaDefinitionRequest(value: object): value is UpsertSchemaDefinitionRequest {
    if (!('slug' in value) || value['slug'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('schema' in value) || value['schema'] === undefined) return false;
    return true;
}

export function UpsertSchemaDefinitionRequestFromJSON(json: any): UpsertSchemaDefinitionRequest {
    return UpsertSchemaDefinitionRequestFromJSONTyped(json, false);
}

export function UpsertSchemaDefinitionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertSchemaDefinitionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'slug': json['slug'],
        'title': json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'purpose': json['purpose'] == null ? undefined : json['purpose'],
        'version': json['version'] == null ? undefined : json['version'],
        'active': json['active'] == null ? undefined : json['active'],
        'schema': json['schema'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
    };
}

export function UpsertSchemaDefinitionRequestToJSON(json: any): UpsertSchemaDefinitionRequest {
    return UpsertSchemaDefinitionRequestToJSONTyped(json, false);
}

export function UpsertSchemaDefinitionRequestToJSONTyped(value?: UpsertSchemaDefinitionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'slug': value['slug'],
        'title': value['title'],
        'description': value['description'],
        'purpose': value['purpose'],
        'version': value['version'],
        'active': value['active'],
        'schema': value['schema'],
        'metadata': value['metadata'],
    };
}

